import api from '../config/api';

export const getPointsDetail = (page = 1, pageSize = 100) =>
  api.get(`api/v1/users/point_transactions`, {
    page,
    page_size: pageSize
  });
